<template>
  <fts-dropdown-select ref="dropdown" class="ai-informations-dropdown" content-class="ai-informations-dropdown-menu"
    :offset="[0, 6]" @show="openDropdown">
    <template #toggle>
      <slot name="toggle" />
    </template>

    <template #menu>
      <div>
        <div class="header-options">
          <div v-if="selectedItems.length == informations.length" @click="uncheckAll">
            <font-awesome-icon class="icon" :icon="['fas', 'square-check']" fixed-width />
            Unselect All
          </div>
          <div v-else-if="selectedItems.length > 0" @click="checkAll">
            <font-awesome-icon class="icon" :icon="['fas', 'square-minus']" fixed-width />
            Select All
          </div>
          <div v-else @click="checkAll">
            <font-awesome-icon class="icon-disabled" :icon="['fas', 'square']" fixed-width />
            Select All
          </div>
        </div>
      </div>
      <div class="fts-form-control-filter">
        <input type="text" class="fts-form-control" v-model="search" placeholder="Search" ref="searchInput" />
        <div class="search-icon">
          <fts-spinner :size="14" v-if="searching" />
          <font-awesome-icon :icon="['fas', 'search']" fixed-width v-else />
        </div>
      </div>

      <div class="dropdown-list">
        <div v-for="(x, index) in filteredList" :key="index" class="dropdown-option" :class="[
          x.system ? 'dropdown-option--system' : 'dropdown-option--information',
          { 'dropdown-option--active': selectedItems.includes(x.id) }
        ]" @click="toggleSelect(x)">
          <div class="dropdown-option-icon" v-if="x.icon">
            <i :class="x.icon"></i>
          </div>
          <div>{{ x.displayName }}</div>
        </div>

        <div class="dropdown-no-results" v-if="!filteredList.length && !searching">
          No results found
        </div>
      </div>

      <div class="button-wrapper">
        <button type="button" class="fts-btn fts-btn-raised fts-btn-primary" @click="confirmSelection">
          <font-awesome-icon :icon="['fas', 'check']" fixed-width />Save
        </button>
      </div>

    </template>
  </fts-dropdown-select>
</template>


<script>

import FTSToggleSwitch from '../elements/FTSToggleSwitch';
import FTSDropdownSelect from "../elements/FTSDropdownSelect";
import FTSLabelGroup from '../elements/FTSLabelGroup';
import FTSCheckbox from '../elements/FTSCheckbox';
import commons from '../commons/commons';

export default {
  name: 'AiInformationsDropdown',
  components: {
    'fts-toggle-switch': FTSToggleSwitch,
    "fts-dropdown-select": FTSDropdownSelect,
    'fts-label-group': FTSLabelGroup,
    "fts-checkbox": FTSCheckbox,
  },
  props: {
    informations: Array,
    initialSelected: Array,
  },
  emits: ['select'],
  data() {
    return {
      search: '',
      searching: false,
      selectedItems: [],
    }
  },
  computed: {
    filteredList() {
      const query = this.search.toLowerCase();
      return this.informations
        .filter(item => item.displayName.toLowerCase().includes(query))
        .map(item => ({
          ...item,
          icon: commons.informationIcon(item.type),
        }));
    },
  },
  methods: {
    checkAll() {
      this.selectedItems = this.informations.map((x) => x.id);
    },
    uncheckAll() {
      this.selectedItems = [];
    },
    openDropdown() {
      this.search = '';
      this.searching = false;
      this.selectedItems = [...(this.initialSelected || [])];
    },
    toggleSelect(item) {
      const index = this.selectedItems.indexOf(item.id);
      if (index !== -1) {
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item.id);
      }
    },
    confirmSelection() {
      this.$emit('select', [...this.selectedItems]);
      this.$refs.dropdown.$refs.popper.doClose();
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.ai-informations-dropdown-menu {
  min-height: 50px;
  padding: 0.5rem;
  background: #fff;
  border: 1px solid #ddd;
  text-align: center;
  color: #aaa;
}

.header-options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  font-size: 12px;
  margin-top: 4px;
  margin-right: 6px;
  color: var(--fts-default);
  cursor: pointer;
}

.header-options .icon {
  color: var(--fts-primary);
}

.header-options .icon-disabled {
  color: var(--fts-border);
}

.button-wrapper {
  bottom: 0;
  right: 0;
  padding-top: 1rem;
}
</style>
